export interface UploadedFile {
  aid: string;
  filename: string;
  ct: string;
  s: number;
}

/** Upload one file through the BFF → Zimbra FileUploadServlet; returns its aid. */
export async function uploadFile(file: File, csrfToken: string): Promise<UploadedFile[]> {
  const form = new FormData();
  form.append('file', file);
  const res = await fetch('/api/upload', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'x-zwf-csrf': csrfToken },
    body: form,
  });
  if (!res.ok) {
    throw new Error(`Upload failed (${res.status})`);
  }
  const data = (await res.json()) as { files: UploadedFile[] };
  return data.files;
}
